import uniqueId from 'lodash/uniqueId'
import { ChangeEvent, useCallback } from 'react'

import { Color } from '../../../../enums/color'
import { useForm } from '../../../Form'
import { Icon } from '../../../Icon'
import { Text } from '../../../Text'
import { Tooltip } from '../../../Tooltip'
import { ToggleGroupItem as ToggleGroupItemType } from '../../types/toggleGroupItem'
import * as Styled from './styles'

export interface ToggleGroupItemProps {
  disabled?: boolean
  groupCheckedValue?: string
  item: ToggleGroupItemType
  name: string
  onChange: (event: ChangeEvent<HTMLInputElement>) => void
}

export const ToggleGroupItem = ({ disabled, groupCheckedValue, item, name, onChange }: ToggleGroupItemProps) => {
  const { icon, tooltipLabel, label, value } = item
  const { name: formName } = useForm()

  const isChecked = groupCheckedValue === value
  const id = `${formName}-${uniqueId('toggle-group-item-')}-${value}`
  const shouldDisplayLabel = !!label
  const shouldDisplayIcon = !!icon

  const getIconColor = useCallback(() => {
    if (disabled) {
      return Color.Grey400
    }

    if (isChecked) {
      return Color.Grey950
    }

    return Color.Grey800
  }, [disabled, isChecked])

  return (
    <Styled.ToggleGroupItemWrapper checked={isChecked} disabled={disabled}>
      <Tooltip forceHidden={!tooltipLabel} label={tooltipLabel} placement="top">
        <Styled.NativeRadio checked={isChecked} id={id} name={name} onChange={onChange} type="radio" value={value} />
        <Styled.Control hasLargePadding={shouldDisplayLabel}>
          {shouldDisplayIcon && <Icon icon={icon} color={getIconColor()} />}
          {shouldDisplayLabel && (
            <Text colorVariant="label" weight="bold">
              {label}
            </Text>
          )}
        </Styled.Control>
      </Tooltip>
    </Styled.ToggleGroupItemWrapper>
  )
}
